export default __webpack_public_path__ + "static/media/8869-morphix.51265f9b.pdf";